import { motion } from "framer-motion";

const line = {
  hidden: { y: "115%" },
  show: (i = 0) => ({
    y: 0,
    transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.15 + i * 0.12 },
  }),
};

export function RevealLine({ children, i = 0, className = "" }) {
  return (
    <span className="line-reveal">
      <motion.span variants={line} initial="hidden" animate="show" custom={i} className={className}>
        {children}
      </motion.span>
    </span>
  );
}

export function RevealLineScroll({ children, i = 0, className = "" }) {
  return (
    <span className="line-reveal">
      <motion.span
        initial={{ y: "115%" }}
        whileInView={{ y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 0.05 + i * 0.1 }}
        className={className}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
